import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { FormHelper } from '@helpers/form.helper';
import { EntrySummaryModel } from '@data-layer/models/entry-summaries';
import { CompanyModel } from '@data-layer/models/companies';

@Component({
  selector: 'es-duties-type-form-desktop',
  template: `
    <es-shipment-duties-payment-form-desktop
      [entrySummary]="entrySummary"
      [formGroup]="formGroup"
      [isSidebar]="true"
    ></es-shipment-duties-payment-form-desktop>

    <div class="sidebar-form-buttons" (click)="saveData()">
      <button type="button" class="btn btn-primary">{{ 'BUTTON.SAVE' | translate }}</button>
    </div>
  `,
  styleUrls: ['./es-duties-type-desktop.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EsDutiesTypeDesktopComponent implements OnInit {
  @Input() public entrySummary: EntrySummaryModel;
  @Input() public company: CompanyModel;
  @Output() public dataSaved: EventEmitter<EntrySummaryModel> = new EventEmitter<EntrySummaryModel>();

  public formGroup: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder, private fh: FormHelper) {}

  public ngOnInit(): void {
    this.formGroup = this.fh.createEntryShipmentFormGroup(this.company?.authorizationAgreementAccepted && !!this.company?.payerUnitNumber);
    this.formGroup.patchValue(this.entrySummary);
  }

  public saveData(): void {
    this.dataSaved.emit(this.formGroup.value);
  }
}
